export * from './all-universities';
export * from './top-universities';
export * from './university-ball';
export * from './university-by-id';
export * from './university-by-name';
export * from './university-course';
export * from './university-sort';
